module.exports = __webpack_public_path__ + "static/media/MTL_SL_RUSH4.a7a674d2.png";